// KnowledgeBase.js
// Purpose: Manages the knowledge base, including file uploads, list management, and user interactions.
// Logic: Uses React hooks, context, and APIs to handle CRUD operations and UI modals for the knowledge base.

/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef, useState } from "react";
import {
  Button,
  Drawer,
  Dropdown,
  Modal,
  Select,
  Tooltip,
} from "flowbite-react";
import { Input } from "antd";
import { useEffect } from "react";
import useCommonApi from "../hooks/common-apis";
import SuccessModal from "../components/SuccessModal";
import FailureModal from "../components/FailureModal";
import ThreeDotsLoader from "../components/ThreeDotsLoader";
import DeletePopup from "../components/DeletePopup";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { socketService } from "../components/socketService";
import TextEditor from "../components/TextEditor";
import axios from "axios";
import UserContext from "../context/UserContext";
import { clog, isUserOwnerOfWorkspace } from "../lib/utils";

function KnowledgeBase() {
  const navigate = useNavigate();
  const context = useContext(UserContext);
  const { setknowLedgeBaseListGlobal } = context;
  const [uploadFileModal, setUploadFileModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [createOpen, setcreateOpen] = useState(false);
  const [deleting, setdeleting] = useState(false);
  const isOwner = isUserOwnerOfWorkspace();
  const {
    getLoginWithToken,
    createKnowledgeBase,
    createKnowledgeBaseUrl,
    uploadIcon,
    getKnowledgeBaseList,
    deleteFileApi,
  } = useCommonApi();
  const [loginData, setloginData] = useState({});
  const [loading, setloading] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const [knowLedgeBaseList, setknowLedgeBaseList] = useState([]);
  const [selectedKnowledgeBase, setselectedKnowledgeBase] = useState({});
  const [buyerPersona, setbuyerPersona] = useState({});
  const [stringOutput, setstringOutput] = useState("");
  const [buyerData, setbuyerData] = useState({
    business_info: "",
    List_of_products_and_services: "",
    buyer_percona: "",
  });
  const [eventinprocess, seteventinprocess] = useState(null);
  const [loadingList, setloadingList] = useState(false);
  const [drawerType, setdrawerType] = useState({
    empty_table: false,
    upload_files: false,
    from_website: false,
  });
  clog(buyerPersona, "buyerPersona");
  clog(buyerData, "buyerData");
  //
  const [name, setName] = useState("");
  const [website, setwebsite] = useState("");
  const [tags, setTags] = useState([]);
  const [isValid, setIsValid] = useState(true);
  const [buyerSteps, setbuyerSteps] = useState(1);
  const createButtonRef = useRef();
  const createMenuRef = useRef();
  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };
  // clog(params.get("page"));
  const clearFields = () => {
    setName("");
    setTags([]);
    setFiles([]);
    setwebsite("");
    setInputValue("");
    setcreateOpen(false);
    setIsValid(true);
  };

  const handleClose = () => {
    clearFields();
    setIsOpen(false);
  };

  const handleChange = (e) => {
    const inputValue = e.target.value.trim();
    setwebsite(inputValue);

    // const urlPattern =
    //   /^(https?:\/\/)?(www\.)?[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z]{2,6}(\/.*)?$/;
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
    setIsValid(urlPattern.test(inputValue));
  };

  const removeTag = (indexToRemove) => {
    setTags(tags.filter((_, index) => index !== indexToRemove));
  };

  const [files, setFiles] = useState([]);

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    e.target.value = null; // Clear the input after selecting files
  };
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      setTags([...tags, inputValue.trim()]);
      setInputValue(""); // Clear input after adding the tag
    } else {
      if (e.key === "Enter" && inputValue.trim() === "") {
        e.preventDefault();
        return;
      }
      if (e.key === "Backspace" && inputValue === "") {
        removeTag(tags.length - 1);
      }
    }
  };
  const notify = (message, type = "success") =>
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      type: type,
    });
  // Function to get the file icon based on the file type
  function getFileIcon(file) {
    if (file.type.startsWith("image/")) {
      return URL.createObjectURL(file); // Display image preview if it's an image
    }

    switch (file.type) {
      case "application/pdf":
        return "/images/pdf.svg"; // Replace with the correct PDF icon path
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return "/images/doc.svg"; // Replace with the correct Word icon path
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return "/icons/excel-icon.png"; // Replace with the correct Excel icon path
      case "audio/mpeg":
      case "audio/wav":
        return "/images/music.svg"; // Replace with the correct Audio icon path
      // Add more cases for different file types
      default:
        return "/icons/file-icon.png"; // Generic file icon
    }
  }
  const handleDelete = (file) => {
    setFiles(files.filter((f) => f !== file));
  };
  const getLoginWithTokenFn = async (uniq_token) => {
    let response = await getLoginWithToken(uniq_token);
    // if (response) {
    //   localStorage.setItem("login_data", JSON.stringify(response.data.data));
    //   localStorage.setItem("login_token", response.data.token);
    //   setloginData(response.data.data || {});
    //   let data = response.data.data;
    //   if (data?.workspacess?.length === 0) {
    //     localStorage.setItem("workspaces_list", JSON.stringify([]));
    //     localStorage.setItem("selected_workspace", JSON.stringify({}));
    //   } else {
    //     let workspace_id = data.resp_user.workspace_id;
    //     if (workspace_id) {
    //       let workspace = data.workspacess.find(
    //         (item) => item.id == workspace_id
    //       );
    //       if (workspace) {
    //         localStorage.setItem(
    //           "selected_workspace",
    //           JSON.stringify(workspace || {})
    //         );
    //       }
    //     }
    //   }
    //   // navigate("/script");
    //   window.location.reload();
    // }
  };
  // Effect to handle login with token
  useEffect(() => {
    const uniq_token = params.get("uniq_token");
    if (uniq_token) {
      getLoginWithTokenFn(uniq_token);
    } else {
      let login_data = JSON.parse(localStorage.getItem("login_data"));
      if (login_data) {
        setloginData(login_data);
      }
    }
  }, []);
  // clog("clicking...", selectedNestedItem);
  // Function to close the modal
  const closeModalHandlerDelete = () => {
    setOpenModalDelete(undefined);
  };
  // Function to delete a file
  const deleteFile = async () => {
    if (!isOwner) {
      setsuccessFailureMessage(
        "Only workspace owner can delete knowledge base"
      );
      setopenFailureModal("dismissible");
      return;
    }
    setdeleting(true);
    let response = await deleteFileApi({
      knowledge_id: selectedKnowledgeBase?.knowledge_id,
    });
    setdeleting(false);
    closeModalHandlerDelete();
    if (!response?.error) {
      setsuccessFailureMessage(response?.message);
      setopenSuccessModal("dismissible");
      setknowLedgeBaseList((prev) =>
        prev.filter(
          (item) => item?.knowledge_id !== selectedKnowledgeBase?.knowledge_id
        )
      );
      setknowLedgeBaseListGlobal((prev) =>
        prev.filter(
          (item) => item?.knowledge_id !== selectedKnowledgeBase?.knowledge_id
        )
      );
    } else {
      setsuccessFailureMessage(response?.message);
      setopenFailureModal("dismissible");
    }
  };
  const callCreateKnowledgeBase = async () => {
    if (!isOwner) {
      setsuccessFailureMessage(
        "Only workspace owner can create knowledge base"
      );
      setopenFailureModal("dismissible");
      return;
    }
    let login_data = JSON.parse(localStorage.getItem("login_data"));
    let workspace_id = login_data?.resp_user?.workspace_id;
    let doc_files = [];
    setloading(true);
    let data = {
      workspace_id: workspace_id,
      knowledge_name: name,
      knowledge_tags: tags.join(","),
      doc_files: doc_files,
    };
    let response = await createKnowledgeBase(data);
    setloading(false);
    if (response.error) {
      setopenFailureModal("dismissible");
      setsuccessFailureMessage(response.message);
    } else {
      getKnowLedgeBaseListFn();
      // setopenSuccessModal("dismissible");
      // setsuccessFailureMessage(response.message);
      setTimeout(() => {
        notify(response.message);
      }, 200);
    }
    handleClose();
    clog(response);
  };
  const callCreateKnowledgeBaseWebsite = async () => {
    if (!isOwner) {
      setsuccessFailureMessage(
        "Only workspace owner can create knowledge base"
      );
      setopenFailureModal("dismissible");
      return;
    }
    let login_data = JSON.parse(localStorage.getItem("login_data"));
    let workspace_id = login_data?.resp_user?.workspace_id;
    let trimmedWebsite = website.endsWith("/") ? website.slice(0, -1) : website;
    let data = {
      workspace_id: workspace_id,
      knowledge_name: name,
      knowledge_tags: tags.join(","),
      website_url: trimmedWebsite,
    };
    clog(data, "data");
    setloading(true);
    let response = await createKnowledgeBaseUrl(data);
    setloading(false);
    if (response.error) {
      setopenFailureModal("dismissible");
      setsuccessFailureMessage(response.message);
    } else {
      setUploadFileModal(true);
      getKnowLedgeBaseListFn();
      setTimeout(() => {
        notify(response.message);
      }, 200);
      // setopenSuccessModal("dismissible");
      // setsuccessFailureMessage(response.message);
    }
    handleClose();
    clog(response);
  };
  // Function to upload files to the API
  const uploadFileToApi = async (e) => {
    if (!isOwner) {
      setsuccessFailureMessage("Only workspace owner can upload files");
      setopenFailureModal("dismissible");
      return;
    }
    setloading(true);
    let login_data = JSON.parse(localStorage.getItem("login_data"));
    let workspace_id = login_data?.resp_user?.workspace_id;
    let data = {
      workspace_id: workspace_id,
      knowledge_name: name,
      knowledge_tags: tags.join(","),
    };
    let response = await uploadIcon(files, data);
    setloading(false);
    if (response.error) {
      setopenFailureModal("dismissible");
      setsuccessFailureMessage(response.message);
    } else {
      getKnowLedgeBaseListFn();
      // setopenSuccessModal("dismissible");
      // setsuccessFailureMessage(response.message);
      setTimeout(() => {
        notify(response.message);
      }, 200);
    }
    handleClose();
    return response;
  };
  clog(loginData, "loginData");
  // Function to get the knowledge base list
  const getKnowLedgeBaseListFn = async () => {
    let login_data = JSON.parse(localStorage.getItem("login_data") || "{}");
    let workspace_id = login_data?.resp_user?.workspace_id;
    clog(workspace_id, "workspace_id");
    if (!workspace_id) {
      return;
    }
    setloadingList(true);
    let response = await getKnowledgeBaseList(workspace_id);
    setloadingList(false);
    if (response) {
      setknowLedgeBaseList(response?.data || []);
      setknowLedgeBaseListGlobal(response?.data || []);
      setbuyerPersona(response?.buyer_percona || {});
      seteventinprocess(response?.eventinprocess || null);
      sessionStorage.setItem(
        "buyer_persona",
        JSON.stringify(response?.buyer_percona || {})
      );
    } else {
      setknowLedgeBaseList([]);
      setknowLedgeBaseListGlobal([]);
    }
  };
  // Function to get the status of a row based on its status code
  const getRowStatus = (status) => {
    if (status <= 1) {
      return "Pending";
    } else if (status == 2) {
      return "Completed";
    } else {
      return "Failed";
    }
  };
  const [loadingBuyer, setloadingBuyer] = useState(false);
  const [approvingBuyer, setapprovingBuyer] = useState(false);
  // Function to handle buyer persona creation or approval
  const buyerPersonaFn = async (from) => {
    if (!isOwner && from === "approve") {
      setsuccessFailureMessage(
        "Only workspace owner can approve buyer persona"
      );
      setopenFailureModal("dismissible");
      return;
    }
    if (!isOwner && !from) {
      setsuccessFailureMessage("Only workspace owner can create buyer persona");
      setopenFailureModal("dismissible");
      return;
    }
    let data = {};
    if (from === "approve") {
      setapprovingBuyer(true);
      data = {
        id: buyerPersona?._id,
        business_info: buyerData?.business_info,
        List_of_products_and_services: buyerData?.List_of_products_and_services,
        buyer_persona: buyerData?.buyer_percona,
      };
    } else {
      setloadingBuyer(true);
    }
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/buyer_percona`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        notify(response.data.message, "success");
        if (from !== "approve") {
          setbuyerPersona(response?.data?.data || {});
          sessionStorage.setItem(
            "buyer_persona",
            JSON.stringify(response?.data?.data || {})
          );
          setbuyerData({
            business_info: response?.data?.data?.business_info || "",
            List_of_products_and_services:
              response?.data?.data?.List_of_products_and_services || "",
            buyer_percona: response?.data?.data?.buyer_percona || "",
          });
          setstringOutput(response?.data?.data?.business_info || "");
        }
        getKnowLedgeBaseListFn();
        if (from === "approve") {
          handleClose();
        }
      } else {
        notify(response.data.message, "error");
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      clog(error);
      notify(error?.response?.data?.message || error?.message, "error");
    } finally {
      setapprovingBuyer(false);
      setloadingBuyer(false);
    }
  };
  // Effect to fetch knowledge base list on component mount and login data change
  useEffect(() => {
    getKnowLedgeBaseListFn();
  }, [Object.keys(loginData || {}).length]);
  // Effect to handle clicks outside the create button and menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        createButtonRef?.current &&
        !createButtonRef?.current.contains(event.target)
      ) {
        if (
          createMenuRef?.current &&
          createMenuRef?.current.contains(event.target)
        ) {
          return;
        }
        setcreateOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [createButtonRef?.current, createMenuRef?.current]);

  // Effect to initialize socket service and handle notifications
  useEffect(() => {
    if (!socketService.isConnected()) {
      socketService.initialize();
    }
    const handleNotification = (data) => {
      clog("Notification received:", data);
      getKnowLedgeBaseListFn();
    };

    socketService.on("knowledge_notification", handleNotification);
    socketService.on("buyerpercona_notification", handleNotification);

    return () => {
      socketService.off("knowledge_notification", handleNotification);
      socketService.off("buyerpercona_notification", handleNotification);
    };
  }, []);
  return (
    <>
      <h6 className="font-[600] text-[24px]">Knowledge Base</h6>

      <p className="font-[500] text-[16px] py-3">
        Knowledge base helps you to save and use important information. The AI
        Employees will use these important piece of information while they are
        working for you.
      </p>
      {knowLedgeBaseList.length > 0 && (
        <>
          <div className="flex items-center mb-4 gap-4">
            {isOwner ? (
              <button
                className={`${
                  Object.keys(buyerPersona || {}).length > 0 &&
                  buyerPersona?.status > 1
                    ? "text-[#097BA9]"
                    : "text-[#DA1E1E]"
                } font-bold underline py-2 text-[20px]`}
                onClick={() => {
                  if (
                    Object.keys(buyerPersona || {}).length > 0 &&
                    buyerPersona?.business_info
                  ) {
                    setbuyerData({
                      business_info: buyerPersona?.business_info || "",
                      List_of_products_and_services:
                        buyerPersona?.List_of_products_and_services || "",
                      buyer_percona: buyerPersona?.buyer_percona || "",
                    });
                    setstringOutput(buyerPersona?.business_info || "");
                    setdrawerType({
                      empty_table: false,
                      upload_files: false,
                      from_website: false,
                      review_approve: true,
                    });
                    setbuyerSteps(1);
                    setIsOpen(true);
                  } else {
                    if (!loadingBuyer && !approvingBuyer) {
                      if (eventinprocess) {
                        notify(
                          "Please wait, your business info and buyer persona is being processed.",
                          "info"
                        );
                        return;
                      }
                      buyerPersonaFn();
                    }
                  }
                }}
                type="button"
              >
                {Object.keys(buyerPersona || {}).length > 0 &&
                buyerPersona?.status > 1
                  ? "Update Business Info & Buyer Persona"
                  : "Review & Approve Business Info and Buyer Persona"}
              </button>
            ) : (
              <Tooltip
                content="This action can only be done by workspace owner"
                placement="bottom"
              >
                <button
                  className="text-gray-400 font-bold underline py-2 text-[20px] cursor-not-allowed"
                  disabled
                  type="button"
                >
                  {Object.keys(buyerPersona || {}).length > 0 &&
                  buyerPersona?.status > 1
                    ? "Update Business Info & Buyer Persona"
                    : "Review & Approve Business Info and Buyer Persona"}
                </button>
              </Tooltip>
            )}
            <div className="flex items-center">
              {(loadingBuyer || approvingBuyer) && (
                <div className="relative group">
                  <div className="flex items-center bg-blue-100 border border-blue-300 rounded-full px-3 py-2 text-blue-700 cursor-pointer hover:bg-blue-200 transition-colors">
                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-blue-500 border-t-transparent mr-2"></div>
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  {/* Tooltip */}
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    {loadingBuyer &&
                      "Please wait while we fetch your business info and buyer persona."}
                    {approvingBuyer &&
                      "Please wait while we approve your business info and buyer persona."}
                    {/* Tooltip arrow */}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
      <div className="relative">
        <div className="flex my-3 p-0 g-0">
          {isOwner ? (
            <button
              ref={createButtonRef}
              type="button"
              className="flex items-center py-2 w-[280px] me-8 px-[80px] rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75"
              onClick={() => setcreateOpen(true)}
              // onClick={() => notify("Hello")}
            >
              <svg className="icon me-2 text-[14px]">
                <use href="#icon_plus"></use>
              </svg>
              <span className=" text-[18px]">Create</span>
            </button>
          ) : (
            <Tooltip
              content="This action can only be done by workspace owner"
              placement="bottom"
            >
              <button
                type="button"
                className="flex items-center py-2 w-[280px] me-8 px-[80px] rounded-[20px] font-semibold bg-gray-200 text-gray-500 cursor-not-allowed"
                disabled
              >
                <svg className="icon me-2 text-[14px]">
                  <use href="#icon_plus"></use>
                </svg>
                <span className=" text-[18px]">Create</span>
              </button>
            </Tooltip>
          )}
          {/* <div className="ms-auto">
            <div className="flex items-center border border-[#2A2A2A] rounded-full px-4 w-[500px]">
              <svg className="icon me-1">
                <use href="#icon_search"></use>
              </svg>
              <input
                type="text"
                placeholder="Search Knowledge Base"
                className="w-full outline-none border-0 text-gray-700 focus:ring-0"
              />
            </div>
          </div> */}
        </div>

        <div className="absolute mt-0 bg-white left-0">
          {createOpen && (
            <div
              class="border border-gray-300 rounded-[10px] w-[280px] text-center  animation-box shadow-sm"
              ref={createMenuRef}
            >
              {/* <button
                class="w-full text-gray-800 hover:bg-[#F1FBFF]  active:bg-[#F1FBFF] hover:text-[#0D78A9] active:text-[#0D78A9] font-medium py-4 px-4 border-b border-gray-200 rounded-t-lg"
                onClick={() => {
                  setIsOpen(true);
                  clearFields();
                  setdrawerType({
                    empty_table: true,
                    upload_files: false,
                    from_website: false,
                  });
                }}
              >
                Empty Table
                <span class="block text-sm">Start with empty table</span>
              </button> */}
              <button
                // class="w-full bg-white text-gray-800 hover:bg-[#F1FBFF]  active:bg-[#F1FBFF] hover:text-[#0D78A9] active:text-[#0D78A9] font-medium py-4 px-4 border-b border-gray-200"
                className="w-full text-gray-800 hover:bg-[#F1FBFF]  active:bg-[#F1FBFF] hover:text-[#0D78A9] active:text-[#0D78A9] font-medium py-4 px-4 border-b border-gray-200 rounded-t-lg"
                onClick={() => {
                  setIsOpen(true);
                  clearFields();
                  setdrawerType({
                    empty_table: false,
                    upload_files: false,
                    from_website: true,
                  });
                }}
              >
                From Website
                <span class="block text-sm">
                  Import data from a website URL
                </span>
              </button>

              <button
                className="w-full text-gray-800 hover:bg-[#F1FBFF]  active:bg-[#F1FBFF] hover:text-[#0D78A9] active:text-[#0D78A9] font-medium py-4 px-4 border-b border-gray-200 rounded-b-lg hover:rounded-b-lg"
                onClick={() => {
                  setIsOpen(true);
                  clearFields();
                  setdrawerType({
                    empty_table: false,
                    upload_files: true,
                    from_website: false,
                  });
                }}
              >
                Upload Files
                <span class="block text-sm">PDF, Doc</span>
              </button>
            </div>
          )}
        </div>
      </div>
      {/* Knowledge Base List */}
      {loadingList && (
        // Skeleton layout for knowledge base cards
        <div className="mt-4 space-y-4">
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="flex justify-between items-center border rounded-[20px] px-4 py-6 shadow-md bg-white"
            >
              {/* Left Side: Name and file info */}
              <div className="flex items-center">
                <div className="h-4 w-40 bg-gray-300 rounded skeleton-wave mr-6"></div>
                <div className="flex items-center border-l pl-4">
                  <div className="w-5 h-5 bg-gray-300 rounded skeleton-wave mr-2"></div>
                  <div className="h-4 w-24 bg-gray-300 rounded skeleton-wave"></div>
                </div>
              </div>
              {/* Status pill */}
              <div className="h-6 w-24 bg-gray-300 rounded-full skeleton-wave"></div>
              {/* Right Side: actions placeholder */}
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 bg-gray-300 rounded-full skeleton-wave"></div>
                <div className="w-6 h-6 bg-gray-300 rounded-full skeleton-wave"></div>
              </div>
            </div>
          ))}
        </div>
      )}
      {knowLedgeBaseList.map((item, index) => (
        <div
          className="flex justify-between items-center border rounded-[20px] px-4 py-6 shadow-md bg-white mb-4 hover:text-[#097BA9] mt-4 cursor-pointer"
          onClick={() => {
            localStorage.setItem(
              "selected-knowledge-base",
              JSON.stringify(item)
            );
            setTimeout(() => {
              navigate(`/knowledge/knowledgebase-details`);
            }, 100);
          }}
        >
          {/* Left Side: Text and File Info */}
          <div className="flex items-center cursor-pointer">
            <span className="font-medium mr-4">{item?.knowledge_name}</span>
            <div className="border-l pl-4 flex items-center">
              <svg className="icon me-2">
                <use href="#icon_file" />
              </svg>
              {item?.file_count} Files
            </div>
          </div>
          <div
            className="content"
            style={{
              fontWeight: "500",
              color: item?.status === 2 ? "#5D9C46" : "#EB9C43",
            }}
          >
            {getRowStatus(item?.status)}
          </div>
          {/* Right Side: Delete Button */}
          <div
            className="flex items-center dot-btn"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {/* <div
              className="content"
              style={{
                fontWeight: "500",
                color: item?.status === 2 ? "#5D9C46" : "#EB9C43",
              }}
            >
              {getRowStatus(item?.status)}
            </div> */}
            <Dropdown
              className="p-0 m-0 border-0"
              label={
                <svg className="icon w-6 h-6 text-gray-400 hover:text-black">
                  <use href="#icon_dots" />
                </svg>
              }
            >
              {isOwner ? (
                <Dropdown.Item
                  className="py-0 px-2"
                  onClick={(e) => {
                    clog("Edit");
                    setselectedKnowledgeBase(item);
                    setOpenModalDelete("dismissible");
                  }}
                >
                  <svg className="icon me-2">
                    <use href="#icon_delete"></use>
                  </svg>
                  Delete
                </Dropdown.Item>
              ) : (
                <Tooltip
                  content="This action can only be done by workspace owner"
                  placement="left"
                >
                  <Dropdown.Item
                    className="py-0 px-2 cursor-not-allowed opacity-50"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <svg className="icon me-2">
                      <use href="#icon_delete"></use>
                    </svg>
                    Delete
                  </Dropdown.Item>
                </Tooltip>
              )}
            </Dropdown>
          </div>
        </div>
      ))}
      <Drawer
        className={`h-full ${
          drawerType.review_approve ? "w-[1050px]" : "w-[600px]"
        } px-0 emty-modal`}
        open={isOpen}
        onClose={handleClose}
        position="right"
      >
        <button
          data-testid="close-drawer"
          className="absolute end-2.5 top-2.5 flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400 hover:text-gray-900 dark:hover:text-white"
          onClick={() => setIsOpen(false)}
        >
          <svg className="icon text-[28px]">
            <use href="#icon_close"></use>
          </svg>
        </button>
        <h2 className="absolute start-[15px] top-[8px] text-[24px] font-[600]">
          {drawerType.empty_table && "Empty Table"}
          {drawerType.upload_files && "Upload Files"}
          {drawerType.from_website && "From Website"}
          {drawerType.review_approve && "Review & Approve in Three Steps"}
        </h2>
        {drawerType.review_approve && (
          <>
            <Drawer.Items>
              <div className="h-[1px] bg-[#E9EBF0] mt-[40px]"></div>
              {/* Review steps design */}
              <div className="flex items-center px-0 mx-0 pt-8 pb-4">
                {/* Step 1 */}
                <div
                  className="flex flex-col items-center"
                  style={{ minWidth: "180px" }}
                >
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#5E78F4] to-[#F14CE2] flex items-center justify-center text-white text-5xl font-bold shadow-md">
                    1
                  </div>
                  <div className="mt-4 text-black text-2xl font-semibold">
                    Business Info
                  </div>
                </div>
                {/* Divider */}
                <div className="h-0.5 bg-gray-200 w-[200px] mx-4 -mt-8"></div>
                {/* Step 2 */}
                <div
                  className="flex flex-col items-center"
                  style={{ minWidth: "180px" }}
                >
                  <div
                    className={`w-16 h-16 rounded-full bg-gradient-to-br from-[#5E78F4] to-[#F14CE2] flex items-center justify-center text-white text-5xl font-bold ${
                      buyerSteps === 1 && "opacity-60"
                    }`}
                  >
                    2
                  </div>
                  <div
                    className={`mt-4 ${
                      buyerSteps === 1 && "text-gray-400"
                    } text-2xl font-semibold text-center`}
                  >
                    Services/Products/Features
                  </div>
                </div>
                {/* Divider */}
                <div className="h-0.5 bg-gray-200 w-[200px] mx-4 -mt-8"></div>
                {/* Step 3 */}
                <div
                  className="flex flex-col items-center"
                  style={{ minWidth: "180px" }}
                >
                  <div
                    className={`w-16 h-16 rounded-full bg-gradient-to-br from-[#5E78F4] to-[#F14CE2] flex items-center justify-center text-white text-5xl font-bold ${
                      (buyerSteps === 1 || buyerSteps === 2) && "opacity-60"
                    }`}
                  >
                    3
                  </div>
                  <div
                    className={`mt-4 ${
                      (buyerSteps === 1 || buyerSteps === 2) && "text-gray-400"
                    } text-2xl font-semibold`}
                  >
                    Buyer Persona
                  </div>
                </div>
              </div>
              {/* End steps design */}
              {loadingBuyer && (
                <div className="flex flex-col items-center w-full h-96">
                  <div className="mb-2">
                    <Loader />
                  </div>
                  <div className="my-2 text-lg font-semibold">
                    Please wait while we fetch your business info and buyer
                    persona.
                  </div>
                </div>
              )}
              {!loadingBuyer && (
                <TextEditor
                  stringOutput={stringOutput}
                  setstringOutput={setstringOutput}
                  from="buyer"
                  buyerData={buyerData}
                  setbuyerData={setbuyerData}
                  buyerSteps={buyerSteps}
                />
              )}
              <div className="sticky bottom-0 left-0 right-0 bg-white z-10 -mb-[20px]">
                <div className="h-[1px] bg-[#E9EBF0]"></div>
                {/* Add Approve Button after TextEditor */}
                {buyerSteps === 1 ? (
                  <div className="flex justify-end px-8 py-4">
                    <div>
                      <button
                        type="button"
                        className="w-[200px] px-8 py-2 bg-white border border-black font-bold rounded-full text-lg shadow hover:opacity-90 transition flex items-center justify-center disabled:opacity-60"
                        onClick={() => {
                          setbuyerSteps(2);
                          setstringOutput(
                            buyerData?.List_of_products_and_services || ""
                          );
                        }}
                        disabled={
                          loadingBuyer ||
                          Object.keys(buyerPersona || {}).length === 0
                        }
                      >
                        Next
                        <span className="ml-4">&#8594;</span>
                      </button>
                    </div>
                  </div>
                ) : buyerSteps === 2 ? (
                  <div className="flex justify-between items-center px-8 py-4">
                    <div>
                      <button
                        type="button"
                        className="w-[200px] px-8 py-2 bg-white border border-black font-bold rounded-full text-lg shadow hover:opacity-90 transition flex items-center justify-center"
                        onClick={() => {
                          setbuyerSteps(1);
                          setstringOutput(buyerData?.business_info || "");
                        }}
                      >
                        <span className="mr-4">&#8592;</span> Back
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="w-[200px] px-8 py-2 bg-white border border-black font-bold rounded-full text-lg shadow hover:opacity-90 transition flex items-center justify-center disabled:opacity-60"
                        onClick={() => {
                          setbuyerSteps(3);
                          setstringOutput(buyerData?.buyer_percona || "");
                        }}
                        disabled={
                          loadingBuyer ||
                          Object.keys(buyerPersona || {}).length === 0
                        }
                      >
                        Next
                        <span className="ml-4">&#8594;</span>
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-between items-center px-8 py-4">
                    <div>
                      <button
                        type="button"
                        className="w-[200px] px-8 py-2 bg-white border border-black font-bold rounded-full text-lg shadow hover:opacity-90 transition flex items-center justify-center"
                        onClick={() => {
                          setbuyerSteps(2);
                          setstringOutput(
                            buyerData?.List_of_products_and_services || ""
                          );
                        }}
                      >
                        <span className="mr-4">&#8592;</span> Back
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="w-[200px] px-8 py-2 bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-white font-bold rounded-full text-lg shadow hover:opacity-90 transition flex justify-center items-center"
                        onClick={() => buyerPersonaFn("approve")}
                        disabled={approvingBuyer}
                      >
                        {approvingBuyer ? (
                          <Loader />
                        ) : (
                          <>
                            {buyerPersona?.status > 1 ? "Update" : "Approve"}
                            <span className="ml-4">&#8594;</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </Drawer.Items>
          </>
        )}
        {!drawerType.review_approve && (
          <>
            <Drawer.Items>
              <div className="h-[1px] bg-[#E9EBF0] mt-[40px]"></div>
              <div className="p-[20px]">
                <form className="">
                  <div className="mb-6">
                    {" "}
                    <label
                      className="block text-gray-700 text-[18px] font-[600] mb-2"
                      htmlFor="name"
                    >
                      Name
                    </label>
                    <input
                      id="name"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter name"
                      className="w-full px-4 py-2 border border-gray-300 focus:outline-none focus:border-blue-500 shadow-md rounded-full bg-[#FFFFFF]"
                    />
                  </div>

                  <div className="mb-6">
                    <label
                      className="block text-gray-700 text-[18px] font-[600] mb-2"
                      htmlFor="tags"
                    >
                      Tags
                    </label>
                    <div className="flex flex-wrap items-center bg-[#FFFFFF] p-2 rounded-[15px] border border-gray-300 shadow-md tags-input">
                      {tags.map((tag, index) => (
                        <div
                          key={index}
                          className="bg-blue-500 text-white text-sm px-3 py-1 rounded-full mr-2 my-1 flex items-center"
                        >
                          {tag}
                          <button
                            className="ml-2 text-white font-bold"
                            onClick={(e) => {
                              e.preventDefault();
                              removeTag(index);
                            }}
                          >
                            &times;
                          </button>
                        </div>
                      ))}
                      <input
                        type="text"
                        className="flex-grow p-2"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Type and press Enter"
                      />
                    </div>
                  </div>
                  {drawerType.upload_files && (
                    <>
                      {/* Preview Selected Files */}
                      {files.length > 0 && (
                        <div className="mb-6">
                          <label className="block text-gray-700 text-[18px] font-bold mb-2">
                            Selected Files:
                          </label>
                          <ul className="flex flex-wrap items-center space-x-4">
                            {files.map((file, index) => (
                              <li
                                key={index}
                                className="flex flex-col items-center text-gray-600 mb-4 w-24"
                              >
                                <div className="relative">
                                  <img
                                    src={getFileIcon(file)} // Using the function to get the correct icon or preview
                                    alt="File Preview"
                                    className="w-16 h-16 object-cover rounded-lg"
                                  />
                                  <button
                                    className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleDelete(file);
                                    }}
                                  >
                                    &times;
                                  </button>
                                </div>
                                <span className="mt-2 text-sm text-center">
                                  {file.name.length > 10
                                    ? `${file.name.substring(0, 10)}...`
                                    : file.name}
                                </span>
                              </li>
                            ))}
                            {files.length > 0 && (
                              <li>
                                <div className="flex justify-center items-center">
                                  <label
                                    htmlFor="fileUpload"
                                    className="cursor-pointer flex flex-col justify-center items-center w-[120px] h-[120px] "
                                  >
                                    <div className="bg-gradient-to-r from-purple-500 to-blue-500 w-[60px] h-[60px] rounded-full flex justify-center items-center active:from-purple-600 active:to-blue-600">
                                      <svg className="icon text-[14px] text-white">
                                        <use href="#icon_plus"></use>
                                      </svg>
                                    </div>
                                  </label>
                                  <input
                                    id="fileUpload"
                                    type="file"
                                    className="hidden"
                                    multiple
                                    accept=".pdf,.doc,.docx"
                                    onChange={handleFileChange}
                                  />
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>
                      )}

                      {/* File Upload Section */}
                      {files.length === 0 && (
                        <div className="mb-6">
                          <label
                            className="block text-gray-700 text-[18px] font-bold mb-2"
                            htmlFor="fileUpload"
                          >
                            Upload Multiple Files
                          </label>
                          <div className="flex justify-center items-center">
                            <label
                              htmlFor="fileUpload"
                              className="cursor-pointer flex flex-col justify-center items-center w-[120px] h-[120px] bg-[#E9F2FF] rounded-[30px] shadow-md active:bg-[#D1E4FF] active:shadow-inner"
                            >
                              <div className="bg-gradient-to-r from-purple-500 to-blue-500 w-[60px] h-[60px] rounded-full flex justify-center items-center active:from-purple-600 active:to-blue-600">
                                <svg className="icon text-[14px] text-white">
                                  <use href="#icon_plus"></use>
                                </svg>
                              </div>
                            </label>
                            <input
                              id="fileUpload"
                              type="file"
                              className="hidden"
                              multiple
                              accept=".pdf,.doc,.docx"
                              onChange={handleFileChange}
                              // onChange={uploadFileToApi}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  {drawerType.from_website && (
                    <>
                      <div className="mb-6">
                        {" "}
                        <label
                          className="block text-gray-700 text-[18px] font-bold mb-2"
                          htmlFor="WebsiteURL"
                        >
                          Website URL
                        </label>
                        <input
                          id="name"
                          type="text"
                          value={website}
                          onChange={handleChange}
                          placeholder="https://www.abc.com"
                          className="w-full px-4 py-2 border border-gray-300 focus:outline-none focus:border-blue-500 shadow-md rounded-full bg-[#FFFFFF]"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                            }
                          }}
                        />
                        {!isValid && (
                          <p className="text-red-500 pt-2">
                            Please enter a valid URL.
                          </p>
                        )}
                      </div>
                    </>
                  )}

                  {/* Submit Button */}
                  <div className="flex justify-center w-full">
                    <button
                      type="button"
                      className="mb-[40px] py-2 w-[240px] px-[80px] rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75"
                      disabled={loading || !isValid}
                      onClick={() => {
                        if (drawerType.upload_files) {
                          uploadFileToApi();
                        } else if (drawerType.from_website) {
                          callCreateKnowledgeBaseWebsite();
                        } else if (drawerType.empty_table) {
                          callCreateKnowledgeBase();
                        }
                      }}
                    >
                      <span className=" text-[18px]">
                        {loading ? (
                          <div className="flex items-center">
                            <div>Creating</div>
                            <div>
                              <ThreeDotsLoader />
                            </div>
                          </div>
                        ) : (
                          <>Create</>
                        )}
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </Drawer.Items>
          </>
        )}
      </Drawer>
      {/* table */}
      {/* <div className="p-6">
            <div className="space-x-4 py-4">
                <button className="bg-gray-100 text-black px-4 py-2 border border-gray-300 rounded-md">
                    Download
                </button>
                <button className="bg-gray-100 text-black px-4 py-2 border border-gray-300 rounded-md">
                    Import
                </button>
            </div>           
            <div className="overflow-x-auto">
                <table className="min-w-full border-collapse border border-gray-300">
                <thead className="rounded-t-[20px]">
                    <tr className="bg-gray-100">
                    <th className="border border-gray-300 px-6 py-3">S.No</th>
                    <th className="border border-gray-300 px-6 py-3">Page Name</th>
                    <th className="border border-gray-300 px-6 py-3">Page URL</th>
                    <th className="border border-gray-300 px-6 py-3">+ Add Column</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: 7 }).map((_, index) => (
                    <tr key={index} className="text-center">
                        <td className="border border-gray-300 px-6 py-3">{index + 1}</td>
                        <td className="border border-gray-300 px-6 py-3 text-left">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam sit.
                        </td>
                        <td className="border border-gray-300 px-6 py-3">
                        <a
                            href="https://www.w3.org/dummy.html"
                            className="text-blue-500 underline"
                        >
                            https://www.w3.org/dummy.html
                        </a>
                        </td>
                        <td className="border border-gray-300 px-6 py-3">+ Add Column</td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>

            <div className="flex justify-between items-center mt-6">
                <div className="flex items-center space-x-1">
                <button className="text-gray-500"> &lt; </button>
                <button className="bg-blue-500 text-white rounded-full w-8 h-8">1</button>
                <button className="bg-gray-100 text-black rounded-full w-8 h-8">2</button>
                <span className="text-gray-500">......</span>
                <button className="bg-gray-100 text-black rounded-full w-8 h-8">10</button>
                <button className="text-gray-500"> &gt; </button>
                </div>
            </div>
        </div> */}
      <SuccessModal
        open={openSuccessModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <FailureModal
        open={openFailureModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <DeletePopup
        openModal={openModalDelete}
        onClose={closeModalHandlerDelete}
        deleteFile={deleteFile}
        deleting={deleting}
      />
      <Modal
        show={uploadFileModal}
        onClose={() => setUploadFileModal(false)}
        popup
        className="mark-waiting-modal"
        dismissible
      >
        <Modal.Header />
        <Modal.Body>
          <div className="space-y-6">
            <div className="flex">
              <div className="w-full h-full max-w-[380px] max-h-[380px] mx-auto grd-br">
                <img src="/images/cloud-file.gif" alt="mark" />
              </div>
            </div>
            <p className="title text-center text-[24px] font-[700] pt-3 pb-0">
              Importing Website
            </p>
            <p className="text-center text-[20px] font-[500]">
              This process may take from few minutes to several hours depending
              on the website size.
              <br />
              Please close this window, this process will run in background. We
              will notify you when the import process completed
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default KnowledgeBase;
